const AppRoutes = {
    home: '/',
    about: '/about',
    team: '/team',
    whyStellar: '/why-stellar-lumens',
    contact: '/contact',
    creators: '/all-creators',
    howitworks: '/how-it-works',
    CommGuide: '/community-guidelines',
    faq: '/faq',
    privacy: '/privacy-policy',
    terms: '/terms-of-service',
    gdpr: '/gdpr-compliance',
    security: '/security',
    start: '/start',
    user: '/:user',
    login: '/user/signin',
    signup: '/user/signup',
    forgotpass: '/user/forgotpassword',
    changepas: '/user/changepassword',
    dashboard: '/user/dashboard',
    accsett: '/user/accountsettings',
    deposit: '/user/deposit',
    withdraw: '/user/withdraw',
    history: '/user/history',
    profileedit: '/user/profile-edit',
    acchistry: '/user/accesshistory',
    google: '/auth/google',
    mobilenav: '/mobilenav',
    refund: '/refund-policy',
    resetpass: '/user/resetpass/:authToken',
    akolades: '/user/akolades',
    referrals: '/user/referrals',
    refredirect: '/a/:refcode',
    tokenhistory: '/user/tokenhistory',
    createapp: '/user/app/create',
    listapp: '/user/app/list',
    confirmapptxn: '/tx/:uid'
}

export default AppRoutes
